<template>
  <div class="sub-header">
    <img
      src="static/img/leakcentral_horizontal.svg"
      class="mobile-logo"
      alt="mobile-logo"
    >
    <span class="mobile-minimizer">
      <button
        type="button"
        class="navbar-toggler mobile-sidebar-toggler d-lg-none mobile-header"
        @click="mobileSidebarToggle"
      >
        <span class="navbar-toggler-icon" />
      </button>
    </span>
  </div>
</template>

<script>
  export default {
    name: 'SubHeader',

    methods: {
      mobileSidebarToggle (e) {
        e.preventDefault()
        document.body.classList.toggle('sidebar-mobile-show')
      }
    }
  }
</script>
